import { chargersWizardData } from './chargers';
import { gen3WizardData } from './gen3Rings';
import { gen4WizardData } from './gen4Rings';
import type { WizardData } from './types';

const wizardData: WizardData = {
  ...chargersWizardData,
  ...gen3WizardData,
  ...gen4WizardData,
};

export default wizardData;
